export const CAMPOS_SEMELHANTES_ORGANIZACAO = {
  NOME: "organizacao_nome",
  CPF_CNPJ: "organizacao_cpfCnpj",
};
